import { Component, ElementRef, EventEmitter, inject, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SnackbarService } from '@app/services/snackbar.service';

@Component({
    selector: 'app-camera-snapshot',
    styleUrls: ['./camera-snapshot.component.scss'],
    templateUrl: './camera-snapshot.component.html',
    imports: [MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatSnackBarModule],
})
export class CameraSnapshotComponent implements OnInit, OnDestroy {
    private readonly snackbarService = inject(SnackbarService);

    public loading: boolean = true;
    public showCameraPreview: boolean = true;
    public cameraError: boolean = false;

    @Output() public snapshot: EventEmitter<File> = new EventEmitter();

    private cameraPreviewElement: HTMLVideoElement;
    private cameraCanvasElement: HTMLCanvasElement;
    private imagesCounter: number = 1;

    @ViewChild('cameraPreview')
    public set cameraPreview(cameraPreview: ElementRef<HTMLVideoElement>) {
        this.cameraPreviewElement = cameraPreview?.nativeElement;
    }

    @ViewChild('cameraCanvas')
    public set cameraCanvas(cameraCanvas: ElementRef<HTMLCanvasElement>) {
        this.cameraCanvasElement = cameraCanvas?.nativeElement;
    }

    ngOnInit() {
        this.showCameraPreview = true;

        const userMediaConstraints = {
            video: {
                width: {
                    ideal: 4096,
                },
                height: {
                    ideal: 2160,
                },
            },
        };

        navigator.mediaDevices
            .getUserMedia(userMediaConstraints)
            .then((stream) => {
                this.cameraPreviewElement.srcObject = stream;
            })
            .catch(() => {
                this.cameraError = true;
            })
            .finally(() => {
                this.loading = false;
            });
    }

    public takeSnapshotFromCamera() {
        this.showCameraPreview = false;

        this.cameraCanvasElement.width = this.cameraPreviewElement.videoWidth;
        this.cameraCanvasElement.height = this.cameraPreviewElement.videoHeight;
        this.cameraCanvasElement.getContext('2d').drawImage(this.cameraPreviewElement, 0, 0);
    }

    public confirm() {
        this.cameraCanvasElement.toBlob((blob) => {
            this.snapshot.emit(
                new File([blob], `fotografie-${this.imagesCounter}.png`, {
                    type: 'image/png',
                })
            );
            this.imagesCounter++;
        }, 'image/png');

        this.snackbarService.showSuccess(`Fotografie byla úspěšně vložena jako fotografie-${this.imagesCounter}.png.`);

        this.showCameraPreview = true;
    }

    ngOnDestroy() {
        if (this.cameraPreviewElement?.srcObject) {
            (this.cameraPreviewElement.srcObject as MediaStream).getVideoTracks().forEach((track) => {
                track.stop();
            });
        }
    }
}
